import { ThunkAction } from 'components/redux/types/ThunkAction';
import { FSAWithPayload } from '@collaborator/npm_modules/dist/components/redux';
import { CHAT_NOTIFIER_LOAD_SUCCESS, CHAT_NOTIFIER_LOAD_URL } from 'moduleChatNotifier/constants';
import { NotifierLoadSuccessPayloadType } from 'moduleChatNotifier/actions/types/NotifierLoadSuccessPayloadType';
import { NotifierLoadResponseType } from 'moduleChatNotifier/actions/types/NotifierLoadResponseType';

const chatNotifierLoadSuccess = (
  data: NotifierLoadResponseType,
): FSAWithPayload<NotifierLoadSuccessPayloadType> => ({
  type: CHAT_NOTIFIER_LOAD_SUCCESS,
  payload: {
    countNotViewed: data.countNotViewed,
  },
});

const chatNotifierLoad = (page: number): ThunkAction => (
  dispatch,
  getState,
  { networkService },
) => networkService.getSimple<NotifierLoadResponseType>(CHAT_NOTIFIER_LOAD_URL, {
  params: {
    page,
  },
})
  .then((response) => {
    dispatch(chatNotifierLoadSuccess(response.data));

    return response;
  });

export { chatNotifierLoad };
